import { createReducer } from '@reduxjs/toolkit';
import { apiRequestSuccess } from 'services/api/api.actions';
import { getAllCitiesEndpoint, getCountriesEndpoint } from './geo.config';
import { CityInfo, CountryInfo } from './geo.types';

const initialState = {
  countries: {} as Record<string, CountryInfo>,
  cities: {} as Record<string, CityInfo>,
};

const countriesReducer = createReducer(initialState, (builder) =>
  builder.addCase(
    apiRequestSuccess,
    (state, { payload: { resourceId, response } }) => {
      if (resourceId === getCountriesEndpoint) {
        const countries = response?.data?.countries as
          | CountryInfo[]
          | undefined;

        if (Array.isArray(countries)) {
          state.countries = Object.fromEntries(
            countries.map((country) => [country.sign, country]),
          );
        }
        return;
      }

      if (resourceId === getAllCitiesEndpoint) {
        const cities = response?.data?.cities as CityInfo[] | undefined;

        if (Array.isArray(cities)) {
          state.cities = Object.fromEntries(
            cities.map((city) => [city.description, city]),
          );
        }
        return;
      }
    },
  ),
);

export default countriesReducer;
